import type { Currency } from '@/bindings/Currency'
import type { Timezone } from '@/bindings/Timezone'

// Generated from tzdb zone.tab (country per zone) and the ISO 4217 currency of each
// country, plus the tzdb links a browser may still report as the device zone.
const ZONES_BY_CURRENCY: Record<Currency, readonly Timezone[]> = {
  AED: ['Asia/Dubai'],
  AFN: ['Asia/Kabul'],
  ALL: ['Europe/Tirane'],
  AMD: ['Asia/Yerevan'],
  AOA: ['Africa/Luanda'],
  ARS: ['America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Buenos_Aires'],
  AUD: ['Antarctica/Macquarie', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney', 'Indian/Christmas', 'Indian/Cocos', 'Pacific/Funafuti', 'Pacific/Kanton', 'Pacific/Kiritimati', 'Pacific/Nauru', 'Pacific/Norfolk', 'Pacific/Tarawa'],
  AWG: ['America/Aruba'],
  AZN: ['Asia/Baku'],
  BAM: ['Europe/Sarajevo'],
  BBD: ['America/Barbados'],
  BDT: ['Asia/Dhaka'],
  BGN: ['Europe/Sofia'],
  BHD: ['Asia/Bahrain'],
  BIF: ['Africa/Bujumbura'],
  BMD: ['Atlantic/Bermuda'],
  BND: ['Asia/Brunei'],
  BOB: ['America/La_Paz'],
  BRL: ['America/Araguaina', 'America/Bahia', 'America/Belem', 'America/Boa_Vista', 'America/Campo_Grande', 'America/Cuiaba', 'America/Eirunepe', 'America/Fortaleza', 'America/Maceio', 'America/Manaus', 'America/Noronha', 'America/Porto_Velho', 'America/Recife', 'America/Rio_Branco', 'America/Santarem', 'America/Sao_Paulo'],
  BSD: ['America/Nassau'],
  BTN: ['Asia/Thimphu'],
  BWP: ['Africa/Gaborone'],
  BYN: ['Europe/Minsk'],
  BZD: ['America/Belize'],
  CAD: ['America/Atikokan', 'America/Blanc-Sablon', 'America/Cambridge_Bay', 'America/Creston', 'America/Dawson', 'America/Dawson_Creek', 'America/Edmonton', 'America/Fort_Nelson', 'America/Glace_Bay', 'America/Goose_Bay', 'America/Halifax', 'America/Inuvik', 'America/Iqaluit', 'America/Moncton', 'America/Rankin_Inlet', 'America/Regina', 'America/Resolute', 'America/St_Johns', 'America/Swift_Current', 'America/Toronto', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg'],
  CDF: ['Africa/Kinshasa', 'Africa/Lubumbashi'],
  CHF: ['Europe/Vaduz', 'Europe/Zurich'],
  CLP: ['America/Coyhaique', 'America/Punta_Arenas', 'America/Santiago', 'Pacific/Easter'],
  CNY: ['Asia/Shanghai', 'Asia/Urumqi'],
  COP: ['America/Bogota'],
  CRC: ['America/Costa_Rica'],
  CUP: ['America/Havana'],
  CVE: ['Atlantic/Cape_Verde'],
  CZK: ['Europe/Prague'],
  DJF: ['Africa/Djibouti'],
  DKK: ['America/Danmarkshavn', 'America/Nuuk', 'America/Scoresbysund', 'America/Thule', 'Atlantic/Faeroe', 'Atlantic/Faroe', 'Europe/Copenhagen'],
  DOP: ['America/Santo_Domingo'],
  DZD: ['Africa/Algiers'],
  EGP: ['Africa/Cairo'],
  ERN: ['Africa/Asmara'],
  ETB: ['Africa/Addis_Ababa'],
  EUR: ['Africa/Ceuta', 'America/Cayenne', 'America/Guadeloupe', 'America/Marigot', 'America/Martinique', 'America/Miquelon', 'America/St_Barthelemy', 'Asia/Famagusta', 'Asia/Nicosia', 'Atlantic/Azores', 'Atlantic/Canary', 'Atlantic/Madeira', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Athens', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Busingen', 'Europe/Dublin', 'Europe/Helsinki', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Monaco', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Riga', 'Europe/Rome', 'Europe/San_Marino', 'Europe/Tallinn', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Zagreb', 'Indian/Kerguelen', 'Indian/Mayotte', 'Indian/Reunion'],
  FJD: ['Pacific/Fiji'],
  FKP: ['Atlantic/Stanley'],
  GBP: ['Atlantic/South_Georgia', 'Europe/Guernsey', 'Europe/Isle_of_Man', 'Europe/Jersey', 'Europe/London'],
  GEL: ['Asia/Tbilisi'],
  GHS: ['Africa/Accra'],
  GIP: ['Europe/Gibraltar'],
  GMD: ['Africa/Banjul'],
  GNF: ['Africa/Conakry'],
  GTQ: ['America/Guatemala'],
  GYD: ['America/Guyana'],
  HKD: ['Asia/Hong_Kong'],
  HNL: ['America/Tegucigalpa'],
  HTG: ['America/Port-au-Prince'],
  HUF: ['Europe/Budapest'],
  IDR: ['Asia/Jakarta', 'Asia/Jayapura', 'Asia/Makassar', 'Asia/Pontianak'],
  ILS: ['Asia/Gaza', 'Asia/Hebron', 'Asia/Jerusalem'],
  INR: ['Asia/Calcutta', 'Asia/Kolkata'],
  IQD: ['Asia/Baghdad'],
  IRR: ['Asia/Tehran'],
  ISK: ['Atlantic/Reykjavik'],
  JMD: ['America/Jamaica'],
  JOD: ['Asia/Amman'],
  JPY: ['Asia/Tokyo'],
  KES: ['Africa/Nairobi'],
  KGS: ['Asia/Bishkek'],
  KHR: ['Asia/Phnom_Penh'],
  KMF: ['Indian/Comoro'],
  KPW: ['Asia/Pyongyang'],
  KRW: ['Asia/Seoul'],
  KWD: ['Asia/Kuwait'],
  KYD: ['America/Cayman'],
  KZT: ['Asia/Almaty', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Atyrau', 'Asia/Oral', 'Asia/Qostanay', 'Asia/Qyzylorda'],
  LAK: ['Asia/Vientiane'],
  LBP: ['Asia/Beirut'],
  LKR: ['Asia/Colombo'],
  LRD: ['Africa/Monrovia'],
  LSL: ['Africa/Maseru'],
  LYD: ['Africa/Tripoli'],
  MAD: ['Africa/Casablanca', 'Africa/El_Aaiun'],
  MDL: ['Europe/Chisinau'],
  MGA: ['Indian/Antananarivo'],
  MKD: ['Europe/Skopje'],
  MMK: ['Asia/Rangoon', 'Asia/Yangon'],
  MNT: ['Asia/Hovd', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator'],
  MOP: ['Asia/Macao', 'Asia/Macau'],
  MRU: ['Africa/Nouakchott'],
  MUR: ['Indian/Mauritius'],
  MVR: ['Indian/Maldives'],
  MWK: ['Africa/Blantyre'],
  MXN: ['America/Bahia_Banderas', 'America/Cancun', 'America/Chihuahua', 'America/Ciudad_Juarez', 'America/Hermosillo', 'America/Matamoros', 'America/Mazatlan', 'America/Merida', 'America/Mexico_City', 'America/Monterrey', 'America/Ojinaga', 'America/Tijuana'],
  MYR: ['Asia/Kuala_Lumpur', 'Asia/Kuching'],
  MZN: ['Africa/Maputo'],
  NAD: ['Africa/Windhoek'],
  NGN: ['Africa/Lagos'],
  NIO: ['America/Managua'],
  NOK: ['Arctic/Longyearbyen', 'Europe/Oslo'],
  NPR: ['Asia/Kathmandu', 'Asia/Katmandu'],
  NZD: ['Pacific/Auckland', 'Pacific/Chatham', 'Pacific/Fakaofo', 'Pacific/Niue', 'Pacific/Pitcairn', 'Pacific/Rarotonga'],
  OMR: ['Asia/Muscat'],
  PAB: ['America/Panama'],
  PEN: ['America/Lima'],
  PGK: ['Pacific/Bougainville', 'Pacific/Port_Moresby'],
  PHP: ['Asia/Manila'],
  PKR: ['Asia/Karachi'],
  PLN: ['Europe/Warsaw'],
  PYG: ['America/Asuncion'],
  QAR: ['Asia/Qatar'],
  RON: ['Europe/Bucharest'],
  RSD: ['Europe/Belgrade'],
  RUB: ['Asia/Anadyr', 'Asia/Barnaul', 'Asia/Chita', 'Asia/Irkutsk', 'Asia/Kamchatka', 'Asia/Khandyga', 'Asia/Krasnoyarsk', 'Asia/Magadan', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Sakhalin', 'Asia/Srednekolymsk', 'Asia/Tomsk', 'Asia/Ust-Nera', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yekaterinburg', 'Europe/Astrakhan', 'Europe/Kaliningrad', 'Europe/Kirov', 'Europe/Moscow', 'Europe/Samara', 'Europe/Saratov', 'Europe/Ulyanovsk', 'Europe/Volgograd'],
  RWF: ['Africa/Kigali'],
  SAR: ['Asia/Riyadh'],
  SBD: ['Pacific/Guadalcanal'],
  SCR: ['Indian/Mahe'],
  SDG: ['Africa/Khartoum'],
  SEK: ['Europe/Stockholm'],
  SGD: ['Asia/Singapore'],
  SHP: ['Atlantic/St_Helena'],
  SLE: ['Africa/Freetown'],
  SOS: ['Africa/Mogadishu'],
  SRD: ['America/Paramaribo'],
  SSP: ['Africa/Juba'],
  STN: ['Africa/Sao_Tome'],
  SYP: ['Asia/Damascus'],
  SZL: ['Africa/Mbabane'],
  THB: ['Asia/Bangkok'],
  TJS: ['Asia/Dushanbe'],
  TMT: ['Asia/Ashgabat'],
  TND: ['Africa/Tunis'],
  TOP: ['Pacific/Tongatapu'],
  TRY: ['Europe/Istanbul'],
  TTD: ['America/Port_of_Spain'],
  TWD: ['Asia/Taipei'],
  TZS: ['Africa/Dar_es_Salaam'],
  UAH: ['Europe/Kiev', 'Europe/Kyiv', 'Europe/Simferopol'],
  UGX: ['Africa/Kampala'],
  USD: ['America/Adak', 'America/Anchorage', 'America/Boise', 'America/Chicago', 'America/Denver', 'America/Detroit', 'America/El_Salvador', 'America/Grand_Turk', 'America/Guayaquil', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Kralendijk', 'America/Los_Angeles', 'America/Menominee', 'America/Metlakatla', 'America/New_York', 'America/Nome', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Phoenix', 'America/Puerto_Rico', 'America/Sitka', 'America/St_Thomas', 'America/Tortola', 'America/Yakutat', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Asia/Dili', 'Indian/Chagos', 'Pacific/Chuuk', 'Pacific/Galapagos', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Midway', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pohnpei', 'Pacific/Saipan', 'Pacific/Wake'],
  UYU: ['America/Montevideo'],
  UZS: ['Asia/Samarkand', 'Asia/Tashkent'],
  VES: ['America/Caracas'],
  VND: ['Asia/Ho_Chi_Minh', 'Asia/Saigon'],
  VUV: ['Pacific/Efate'],
  WST: ['Pacific/Apia'],
  XAF: ['Africa/Bangui', 'Africa/Brazzaville', 'Africa/Douala', 'Africa/Libreville', 'Africa/Malabo', 'Africa/Ndjamena'],
  XCD: ['America/Anguilla', 'America/Antigua', 'America/Dominica', 'America/Grenada', 'America/Montserrat', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Vincent'],
  XCG: ['America/Curacao', 'America/Lower_Princes'],
  XOF: ['Africa/Abidjan', 'Africa/Bamako', 'Africa/Bissau', 'Africa/Dakar', 'Africa/Lome', 'Africa/Niamey', 'Africa/Ouagadougou', 'Africa/Porto-Novo'],
  XPF: ['Pacific/Gambier', 'Pacific/Marquesas', 'Pacific/Noumea', 'Pacific/Tahiti', 'Pacific/Wallis'],
  YER: ['Asia/Aden'],
  ZAR: ['Africa/Johannesburg'],
  ZMW: ['Africa/Lusaka'],
  ZWG: ['Africa/Harare'],
}

const BY_ZONE: ReadonlyMap<Timezone, Currency> = new Map(
  Object.entries(ZONES_BY_CURRENCY).flatMap(([currency, zones]) => zones.map((zone) => [zone, currency] as const)),
)

/** The currency of the country a zone belongs to; `undefined` for UTC, Etc/* and unknown zones. */
export function currencyForTimezone(zone: Timezone): Currency | undefined {
  return BY_ZONE.get(zone)
}
